"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cityListTree = cityListTree;
exports.exportTempApi = exportTempApi;
exports.expressAllApi = expressAllApi;
exports.expressDefaultAwitchApi = expressDefaultAwitchApi;
exports.expressDelete = expressDelete;
exports.expressDeleteApi = expressDeleteApi;
exports.expressInfo = expressInfo;
exports.expressList = expressList;
exports.expressOpenSwitchApi = expressOpenSwitchApi;
exports.expressPageApi = expressPageApi;
exports.expressRelateApi = expressRelateApi;
exports.expressSave = expressSave;
exports.expressSyncApi = expressSyncApi;
exports.expressUpdate = expressUpdate;
exports.expressUpdateShow = expressUpdateShow;
exports.shippingDetete = shippingDetete;
exports.shippingSave = shippingSave;
exports.shippingTemplatesList = shippingTemplatesList;
exports.shippingUpdate = shippingUpdate;
exports.templateDetailApi = templateDetailApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * @description 全部物流公司
 */
function expressAllApi(params) {
  return (0, _request.default)({
    url: 'admin/merchant/express/all',
    method: 'get',
    params: params
  });
}
// 物流公司列表
function expressList(data) {
  return (0, _request.default)({
    url: '/admin/platform/express/list',
    method: 'get',
    params: _objectSpread({}, data)
  });
}

// 同步物流公司
function expressSyncApi() {
  return (0, _request.default)({
    url: '/admin/platform/express/sync/express',
    method: 'post'
  });
}

// 物流公司修改状态
function expressUpdateShow(data) {
  return (0, _request.default)({
    url: '/admin/platform/express/update/show',
    method: 'post',
    data: data
  });
}

// 物流公司 编辑
function expressUpdate(data) {
  return (0, _request.default)({
    url: '/admin/platform/express/update',
    method: 'post',
    data: data
  });
}

// 新增物流公司
function expressSave(data) {
  return (0, _request.default)({
    url: '/admin/platform/express/save',
    method: 'post',
    data: data
  });
}

// 删除物流公司
function expressDelete(data) {
  return (0, _request.default)({
    url: '/admin/express/delete',
    method: 'GET',
    params: _objectSpread({}, data)
  });
}
/**
 * @description 物流运费模板列表
 */
function shippingTemplatesList(data) {
  return (0, _request.default)({
    url: '/admin/merchant/shipping/templates/list',
    method: 'get',
    params: _objectSpread({}, data)
  });
}

/**
 * @description 物流运费模板详情
 */
function templateDetailApi(data) {
  return (0, _request.default)({
    url: "/admin/merchant/shipping/templates/info/".concat(data.id),
    method: 'get'
  });
}

/**
 * @description 物流运费模板新增
 */
function shippingSave(data) {
  return (0, _request.default)({
    url: 'admin/merchant/shipping/templates/save',
    method: 'post',
    data: data
  });
}

/**
 * @description 物流运费模板更新
 */
function shippingUpdate(data) {
  return (0, _request.default)({
    url: 'admin/merchant/shipping/templates/update',
    method: 'post',
    data: data
  });
}

/**
 * @description 物流运费模板删除
 */
function shippingDetete(data) {
  return (0, _request.default)({
    url: "admin/merchant/shipping/templates/delete/".concat(data.id),
    method: 'POST'
  });
}

/**
 * @description 城市列表
 */
function cityListTree() {
  return (0, _request.default)({
    url: '/admin/merchant/city/region/city/tree',
    method: 'get'
  });
}

/**
 * @description 查询物流公司面单模板
 */
function exportTempApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/express/template',
    method: 'get',
    params: params
  });
}

/**
 * @description 商户物流公司默认开关
 */
function expressDefaultAwitchApi(id) {
  return (0, _request.default)({
    url: "/admin/merchant/express/default/switch/".concat(id),
    method: 'post'
  });
}

/**
 * @description 商户物流公司删除
 */
function expressDeleteApi(id) {
  return (0, _request.default)({
    url: "/admin/merchant/express/delete/".concat(id),
    method: 'post'
  });
}

// /**
//  * @description 添加电子面单信息
//  * @param data
//  * @returns {*}
//  */
// export function expressUpdate(data) {
//   return request({
//     url: `/admin/merchant/express/update`,
//     method: 'post',
//     data,
//   });
// }

/**
 * @description 商户物流公司开关
 */
function expressOpenSwitchApi(id) {
  return (0, _request.default)({
    url: "/admin/merchant/express/open/switch/".concat(id),
    method: 'post'
  });
}

/**
 * @description 商户关联物流公司
 */
function expressRelateApi(data) {
  return (0, _request.default)({
    url: "/admin/merchant/express/relate",
    method: 'post',
    data: data
  });
}

/**
 * @description 商户物流公司分页列表
 */
function expressPageApi(params) {
  return (0, _request.default)({
    url: "/admin/merchant/express/search/page",
    method: 'GET',
    params: params
  });
}

// 物流公司详情
function expressInfo(data) {
  return (0, _request.default)({
    url: 'admin/platform/express/info',
    method: 'get',
    params: _objectSpread({}, data)
  });
}